export default __webpack_public_path__ + "static/structural4-dc3ce545ae32a78146af561816f52afd.png";